/** Settings, Categories and products tab: the ticket pickers from `vocab.list`; edits through `vocab.*`. */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { VocabLists } from '../../components/settings/vocab-lists';
import { vocabQuery } from '../../lib/queries';
import { describeRpcError, rpc } from '../../lib/rpc';

export const Route = createFileRoute('/settings/vocab')({
  component: Vocab,
});

function Vocab() {
  const qc = useQueryClient();
  const q = useQuery(vocabQuery());
  if (q.error) return <p className="text-body text-alert">{describeRpcError(q.error)}</p>;
  if (!q.data) return <p className="text-body text-ink-3">Loading the lists</p>;
  // Every edit refetches the one query quick capture reads, so the pickers follow at once.
  const refresh = () => qc.invalidateQueries({ queryKey: vocabQuery().queryKey });
  const act = async (work: () => Promise<unknown>) => {
    try {
      await work();
    } catch (err) {
      throw new Error(describeRpcError(err), { cause: err });
    } finally {
      await refresh();
    }
  };
  return (
    <VocabLists
      data={q.data}
      actions={{
        onAdd: (kind, name) => act(() => rpc.vocab.add({ kind, name })),
        onRename: (id, name) => act(() => rpc.vocab.rename({ id, name })),
        onSetActive: (id, active) => act(() => rpc.vocab.setActive({ id, active })),
        onReorder: (kind, ids) => act(() => rpc.vocab.reorder({ kind, ids })),
      }}
    />
  );
}
